import React from "react";
import {makeStyles, Box, Typography, RadioGroup} from "@material-ui/core";
import {
    CreateTacticTextField,
    CreateTacticTreeItem,
} from "./CreateTradePlanTree";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import PositionTacticsDocs from "../../documentation/PositionTacticsDocumentation";
import {useState} from "react";
import {useEffect} from "react";
import {toggleButton} from "../../../../../utils/componentutils/ToggleButton";
import SetupFilterDocs from "../../documentation/SetupFilterDocs";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PriceIntersectsFirstCandleDocs from "../../documentation/PriceIntersectsFirstCandleDocumentation";
import EmaIntersectsFirstCandleDocs from "../../documentation/EmaFirstCandleDocumentation";
import * as PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import TimeOfDayDocumentation from "../../documentation/TimeOfDayDocumentation";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";
import FTFCDocs from "../../documentation/FtfcDocumentation";
import FTFCSetup from "./FTFCSetup";
import FtfcFilterDocs from "../../documentation/FtfcFilterDocumentation";

const useStyles = makeStyles({
    root: {
        //height: 216,
        //flexGrow: 1,
        //maxWidth: 400,
    },
    expanded: {
        color: "green",
    },
});

const boxProps = {
    bgcolor: "background.paper",
    m: 1,
    borderColor: "text.primary",
};

const priceIntersectsFirstCandleId = "priceIntersectsFirstCandle";
const emaIntersectsFirstCandleId = "emaIntersectsFirstCandle";
const timeOfDayId = "timeOfDayId";
const ftfcFilterId = "ftfcFilterId";

export default function SetupFiltersTree(props) {
    //set default values
    let [
        priceIntersectsFirstCandleEnabled,
        setPriceIntersectsFirstCandleEnabled,
        priceIntersectsFirstCandle,
        dispatchPriceIntersectsFirstCandle,
        emaIntersectsFirstCandleEnabled,
        setEmaIntersectsFirstCandleEnabled,
        emaIntersectsFirstCandle,
        dispatchEmaIntersectsFirstCandle,
        timeOfDay,
        dispatchTimeOfDay,
        timeOfDayEnabled,
        setTimeOfDayEnabled,
        ftfcFilter, dispatchFtfcFilter, ftfcFilterEnabled, setFtfcFilterEnabled
    ] = props.setupFilters;

    let expanded = [];
    let selected = [];
    //useEffect(() => {
    let anySelected = false;
    if (priceIntersectsFirstCandleEnabled) {
        expanded.push(priceIntersectsFirstCandleId);
        selected.push(priceIntersectsFirstCandleId);
        anySelected = true;
    }
    if (emaIntersectsFirstCandleEnabled) {
        expanded.push(emaIntersectsFirstCandleId);
        selected.push(emaIntersectsFirstCandleId);
        anySelected = true;
    }
    if (timeOfDayEnabled) {
        expanded.push(timeOfDayId);
        selected.push(timeOfDayId);
        anySelected = true;
    }
    if (ftfcFilterEnabled) {
        expanded.push(ftfcFilterId);
        selected.push(ftfcFilterId);
        anySelected = true;
    }
    if (anySelected) {
        expanded.push("setupFilters");
        selected.push("setupFilters");
    }

    return (
        <BuildTree
            top={props.top}
            setupFilters={props.setupFilters}
            alreadyExpanded={expanded}
            alreadySelected={selected}
            includeDocsInLabel={props.includeDocsInLabel}
        />
    );
}


function BuildTree(props) {
    const classes = useStyles();
    let [
        priceIntersectsFirstCandleEnabled,
        setPriceIntersectsFirstCandleEnabled,
        priceIntersectsFirstCandle,
        dispatchPriceIntersectsFirstCandle,
        emaIntersectsFirstCandleEnabled,
        setEmaIntersectsFirstCandleEnabled,
        emaIntersectsFirstCandle,
        dispatchEmaIntersectsFirstCandle,
        timeOfDay,
        dispatchTimeOfDay,
        timeOfDayEnabled,
        setTimeOfDayEnabled,
        ftfcFilter, dispatchFtfcFilter, ftfcFilterEnabled, setFtfcFilterEnabled
    ] = props.setupFilters;

    var [expanded, setExpanded] = useState([]);
    var [selected, setSelected] = useState([]);
    var [seeFilters, setSeeSetupFilters] = useState(true);

    props.alreadyExpanded.forEach((id) => {
        expanded.push(id);
    });
    props.alreadySelected.forEach((id) => {
        selected.push(id);
    });

    const setSetupFilter = {};
    setSetupFilter["setupFilters"] = [seeFilters, setSeeSetupFilters];
    setSetupFilter[priceIntersectsFirstCandleId] = [
        priceIntersectsFirstCandleEnabled,
        setPriceIntersectsFirstCandleEnabled,
    ];
    setSetupFilter[emaIntersectsFirstCandleId] = [
        emaIntersectsFirstCandleEnabled,
        setEmaIntersectsFirstCandleEnabled,
    ];
    setSetupFilter[timeOfDayId] = [
        timeOfDayEnabled,
        setTimeOfDayEnabled,
    ];

    setSetupFilter[ftfcFilterId] = [
        ftfcFilterEnabled,
        setFtfcFilterEnabled,
    ];


    if (!seeFilters) {
        selected = selected.filter((id) => id !== "setupFilters");
        expanded = expanded.filter((id) => id !== "setupFilters");
    }

    const handleToggle = (event, nodeIds) => {
        setExpanded(nodeIds);
    };

    const handleSelect = (event, nodeId) => {
        let [filterEnabled, setFilterEnabled] = setSetupFilter[nodeId];
        setFilterEnabled(toggleButton(filterEnabled));
        setSelected(nodeId);
    };

    let selectedChanged = false;
    let expandedChanged = false;
    selected = selected.filter((id) => {
        const [filterEnabled, setFilterEnabled] = setSetupFilter[id];
        if (!filterEnabled) {
            selectedChanged = true;
            return false;
        } else {
            return true;
        }
    });
    if (selectedChanged) {
        setSelected(selected);
    }
    expanded = expanded.filter((id) => {
        const [tacticEnabled, setTacticEnabled] = setSetupFilter[id];
        if (!tacticEnabled) {
            expandedChanged = true;
            return false;
        } else {
            return true;
        }
    });
    if (expandedChanged) {
        //console.log("setting selected");
        setExpanded(expanded);
    }
    return (
        <div>
            {props.includeDocsInLabel ? <SetupFilterDocs/> : null}
            <TreeView
                className={classes.root}
                defaultCollapseIcon={<ExpandMoreIcon/>}
                defaultExpandIcon={<ChevronRightIcon/>}
                multiSelect
                expanded={expanded}
                selected={selected}
                onNodeToggle={handleToggle}
                onNodeSelect={handleSelect}
            >
                <TreeItem nodeId="setupFilters" label={<Typography style={{fontSize: 13}}> setup filters</Typography>}>
                    {/*price intersects first candle*/}
                    <CreateTacticTreeItem
                        classes={classes}
                        tacticComponent={
                            <PriceIntersectsFirstCandleComponent
                                priceIntersectsFirstCandle={priceIntersectsFirstCandle}
                                dispatchPriceIntersectsFirstCandle={
                                    dispatchPriceIntersectsFirstCandle
                                }
                            />
                        }
                        nodeId={priceIntersectsFirstCandleId}
                        label="price intersects first candle"
                        tacticEnabledHook={[
                            priceIntersectsFirstCandleEnabled,
                            setPriceIntersectsFirstCandleEnabled,
                        ]}
                        docs={PriceIntersectsFirstCandleDocs}
                    />
                    <CreateTacticTreeItem
                        classes={classes}
                        tacticComponent={
                            <EmaIntersectsFirstCandleComponent
                                emaIntersectsFirstCandle={emaIntersectsFirstCandle}
                                dispatchEmaIntersectsFirstCandle={
                                    dispatchEmaIntersectsFirstCandle
                                }
                            />
                        }
                        nodeId={emaIntersectsFirstCandleId}
                        label="ema intersects first candle"
                        tacticEnabledHook={[
                            emaIntersectsFirstCandleEnabled,
                            dispatchEmaIntersectsFirstCandle,
                        ]}
                        docs={EmaIntersectsFirstCandleDocs}
                    />
                    <CreateTacticTreeItem
                        classes={classes}
                        tacticComponent={
                            <TimeOfDayComponent
                                timeOfDay={timeOfDay}
                                dispatchTimeOfDay={
                                    dispatchTimeOfDay
                                }
                            />
                        }
                        nodeId={timeOfDayId}
                        label="time of day"
                        tacticEnabledHook={[
                            timeOfDayEnabled,
                            dispatchTimeOfDay,
                        ]}
                        docs={TimeOfDayDocumentation}
                    />
                    <CreateTacticTreeItem
                        classes={classes}
                        tacticComponent={
                            <FtfcFilterComponent
                                ftfcFilter={ftfcFilter}
                                dispatchFtfcFilter={
                                    dispatchFtfcFilter
                                }
                            />
                        }
                        nodeId={ftfcFilterId}
                        label="FTFC (The Strat)"
                        tacticEnabledHook={[
                            ftfcFilterEnabled,
                            dispatchFtfcFilter,
                        ]}
                        docs={FtfcFilterDocs}
                    />

                </TreeItem>
            </TreeView>
        </div>
    );
}

function FtfcFilterComponent({ftfcFilter, dispatchFtfcFilter}) {
    return (
        <FTFCSetup
            //top={top}
            dispatchSetUpDetails={dispatchFtfcFilter}
            setupDetailTimeFrames={ftfcFilter.timeFrames}
        />
    )
}

const directions = ["BELOW", "ABOVE"];
const CandleBarriers = ["HIGH", "LOW"];

function PriceIntersectsFirstCandleComponent({
                                                 priceIntersectsFirstCandle,
                                                 dispatchPriceIntersectsFirstCandle,
                                             }) {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="stretch"
            border={1}
            {...boxProps}
        >
            <Grid item container>
                <Grid item xs={12}>
                    <CreateTacticTextField
                        label="Candle Duration"
                        defaultValue={priceIntersectsFirstCandle.candleDuration}
                        onBlurFunc={(ev) =>
                            dispatchPriceIntersectsFirstCandle({
                                candleDuration: ev.target.value,
                            })
                        }
                    />
                </Grid>
                <Grid item xs={12}>
                    <RadioGroup
                        row
                        aria-label="direction"
                        name="direction"
                        value={priceIntersectsFirstCandle.direction}
                        onChange={(ev) => {
                            dispatchPriceIntersectsFirstCandle({
                                direction: ev.target.value,
                            })
                        }}
                    >
                        {directions.map((db) => {
                            //console.log(tu);
                            return (
                                <Grid item xs={5}>
                                    <FormControlLabel
                                        value={db}
                                        key={db}
                                        checked={db === priceIntersectsFirstCandle.direction}
                                        labelPlacement="start"
                                        control={<StyledRadio/>}
                                        label={
                                            <Typography style={{fontSize: 7}}>{db}</Typography>
                                        }
                                    />
                                </Grid>
                            );
                        })}
                    </RadioGroup>
                </Grid>
                <Grid item xs={12}>
                    <RadioGroup
                        row
                        aria-label="candleBarrier"
                        name="candleBarrier"
                        value={priceIntersectsFirstCandle.candleBarrier}
                        onChange={ev => dispatchPriceIntersectsFirstCandle({
                            candleBarrier: ev.target.value,
                        })}

                        //onChange={(ev) => {
                        //console.log(ev.target);
                        //                      />/  dispatchSetUpDetails({
                        //   candleType: ev.target.value,
                        //})
                        //}}
                    >
                        {CandleBarriers.map((cb) => {
                            //console.log(tu);
                            return (
                                <Grid item xs={5}>
                                    <FormControlLabel
                                        value={cb}
                                        key={cb}
                                        checked={cb === priceIntersectsFirstCandle.candleBarrier}
                                        labelPlacement="start"
                                        control={<StyledRadio/>}
                                        label={
                                            <Typography style={{fontSize: 7}}>{cb}</Typography>
                                        }
                                    />
                                </Grid>
                            );
                        })}
                    </RadioGroup>
                </Grid>
            </Grid>
        </Box>
    );
}

function EmaIntersectsFirstCandleComponent(
    {
        emaIntersectsFirstCandle,
        dispatchEmaIntersectsFirstCandle,
    }
) {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="stretch"
            border={1}
            {...boxProps}
        >
            <CreateTacticTextField
                label="First Candle Duration"
                defaultValue={emaIntersectsFirstCandle.firstCandleCandleDuration}
                onBlurFunc={(ev) =>
                    dispatchEmaIntersectsFirstCandle({
                        firstCandleCandleDuration: ev.target.value,
                    })
                }
            />
            <Grid item xs={12}>
                <RadioGroup
                    row
                    aria-label="directions"
                    name="directions"
                    value={emaIntersectsFirstCandle.direction}
                    onChange={(ev) => {
                        dispatchEmaIntersectsFirstCandle({
                            direction: ev.target.value,
                        })
                    }}
                >
                    {directions.map((db) => {
                        //console.log(tu);
                        return (
                            <Grid item xs={5}>
                                <FormControlLabel
                                    value={db}
                                    key={db}
                                    checked={db === emaIntersectsFirstCandle.direction}
                                    labelPlacement="start"
                                    control={<StyledRadio/>}
                                    label={
                                        <Typography style={{fontSize: 7}}>{db}</Typography>
                                    }
                                />
                            </Grid>
                        );
                    })}
                </RadioGroup>
            </Grid>
            <Grid item xs={12}>
                <RadioGroup
                    row
                    aria-label="candleBarrier"
                    name="candleBarrier"
                    value={emaIntersectsFirstCandle.candleBarrier}
                    onChange={ev => dispatchEmaIntersectsFirstCandle({
                        candleBarrier: ev.target.value,
                    })}

                    //onChange={(ev) => {
                    //console.log(ev.target);
                    //                      />/  dispatchSetUpDetails({
                    //   candleType: ev.target.value,
                    //})
                    //}}
                >
                    {CandleBarriers.map((cb) => {
                        //console.log(tu);
                        return (
                            <Grid item xs={5}>
                                <FormControlLabel
                                    value={cb}
                                    key={cb}
                                    checked={cb === emaIntersectsFirstCandle.candleBarrier}
                                    labelPlacement="start"
                                    control={<StyledRadio/>}
                                    label={
                                        <Typography style={{fontSize: 7}}>{cb}</Typography>
                                    }
                                />
                            </Grid>
                        );
                    })}
                </RadioGroup>
            </Grid>
            <CreateTacticTextField
                label="ema Candle Duration"
                defaultValue={emaIntersectsFirstCandle.emaCandleDuration}
                onBlurFunc={(ev) =>
                    dispatchEmaIntersectsFirstCandle({
                        emaCandleDuration: ev.target.value,
                    })
                }
            />
            <CreateTacticTextField
                label="periods"
                defaultValue={emaIntersectsFirstCandle.periodLengths}
                onBlurFunc={(ev) =>
                    dispatchEmaIntersectsFirstCandle({
                        periodLengths: ev.target.value,
                    })
                }
            />
            <FormControlLabel
                labelPlacement="top"
                control={
                    <Checkbox
                        checked={emaIntersectsFirstCandle.associatePerEmaSetup}
                        onChange={(ev) =>
                            dispatchEmaIntersectsFirstCandle({
                                associatePerEmaSetup: ev.target.checked,
                            })
                        }
                        name="associatePerEmaSetup"
                    />
                }
                label={
                    <Typography style={{fontSize: 10}}>
                        associate with ema setup{" "}
                    </Typography>
                }
            />
        </Box>
    );
}

function TimeOfDayComponent(
    {
        timeOfDay, dispatchTimeOfDay
    }
) {
    return (<Box
        display="flex"
        flexDirection="column"
        alignItems="stretch"
        border={1}
        {...boxProps}
    >
        <Grid item container>
            <Grid item xs={6}>
                <CreateTacticTextField
                    label="start hour"
                    defaultValue={timeOfDay.startHour}
                    onBlurFunc={(ev) =>
                        dispatchTimeOfDay({
                            startHour: ev.target.value,
                        })
                    }
                />
            </Grid>
            <Grid item xs={6}>
                <CreateTacticTextField
                    label="start min"
                    defaultValue={timeOfDay.startMinute}
                    onBlurFunc={(ev) =>
                        dispatchTimeOfDay({
                            startMinute: ev.target.value,
                        })
                    }
                />
            </Grid>
            <Grid item xs={6}>
                <CreateTacticTextField
                    label="end hour"
                    defaultValue={timeOfDay.endHour}
                    onBlurFunc={(ev) =>
                        dispatchTimeOfDay({
                            endHour: ev.target.value,
                        })
                    }
                />
            </Grid>
            <Grid item xs={6}>
                <CreateTacticTextField
                    label="end min"
                    defaultValue={timeOfDay.endMinute}
                    onBlurFunc={(ev) =>
                        dispatchTimeOfDay({
                            endMinute: ev.target.value,
                        })
                    }
                />
            </Grid>
        </Grid>
    </Box>);
}
